<template>
  <svg
    :width="width"
    :height="height"
    viewBox="-2 -2 24 24"
    class="icon-chevron-circle-left"
    :class="[`icon-chevron-circle-left--color-${color}`]"
  >
    <path
      xmlns="http://www.w3.org/2000/svg"
      d="M11.828 10l-3.535 3.536a1 1 0 0 0 1.414 1.414l4.243-4.243a1 1 0 0 0 0-1.414L9.707 5.05a1 1 0 0 0-1.414 1.414L11.828 10zM10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10z"
    />
  </svg>
</template>

<script>
  export default {
    name: 'IconFigmaChevron',
    props: {
      color: {
        type: String,
        default: 'grey',
        validator: (value) =>
          [
            'black',
            'grey',
            'blue',
            'light-grey',
            'charcoal',
            'disabled',
          ].includes(value),
      },
      width: {
        type: [Number, String],
        required: false,
        default: 24,
      },
      height: {
        type: [Number, String],
        required: false,
        default: 24,
      },
    },
  };
</script>

<style lang="scss" scoped>
  .icon-chevron-circle-left {
    transition: fill $default-transition-time;
    fill: currentColor;
    &--color-black {
      fill: #000000;
      &:hover {
        fill: lighten(#000000, 5%);
      }
    }
    &--color-grey {
      fill: #a7a9ab;
      &:hover {
        fill: darken(#a7a9ab, 5%);
      }
    }
    &--color-blue {
      fill: #17355c;
      &:hover {
        fill: lighten(#17355c, 5%);
      }
    }
    &--color-light-grey {
      fill: var(--itr-grey);
      &:hover {
        fill: darken(#dbdcde, 5%);
      }
    }
    &--color-charcoal {
      fill: var(--itr-charcoal);
      &:hover {
        fill: darken(#a7a9ab, 5%);
      }
    }
    &--color-disabled {
      fill: var(--itr-grey);
    }
  }
</style>
